import { Card, Col } from "antd";
import Button from "components/Button";
import Grid from "components/Grid";
import Loader from "components/Loader";
import Text from "components/Text";
import { routeConstants } from "constants/routeConstants";
import { formatDistance } from "date-fns";
import {
    budgetType,
    capitalize,
    yesNoType,
} from "pages/Profile/EditProfile/PhysicalDetails/constants";
import { FC, useEffect, useState } from "react";
import { BsArrowLeft, BsHeartFill } from "react-icons/bs";
import { IoLocation } from "react-icons/io5";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppSelector } from "slice";
import {
    useApplyJobMutation,
    useFollowAgentMutation,
    useGetJobByIdQuery,
    useLikeJobMutation,
    useUnFollowAgentMutation,
} from "slice/jobs";
import theme from "theme";
import { addToast } from "../../../components/ToastContainer/ToastStore";
import { FindWorkWrapper } from "../FindWork.styled";
import {
    AgencyIcon,
    AgencyInformation,
    AgencyName,
    AgencySection,
    ContainerParent,
    ContentDivide,
    ContentGrid,
    ContentRow,
    ContentRowLeft,
    ContentRowRight,
    InfoSection,
    PreferenceSection,
    StyledRow,
    TitleSection,
    WorkDetailsContent,
} from "./WorkDetails.styled";

export const WorkDetails: FC = () => {
    const navigateTo = useNavigate();
    const location = useLocation();
    const { id: userId } = useAppSelector((state) => state.user);
    const {
        data: jobDetails,
        refetch,
        isLoading,
    } = useGetJobByIdQuery({
        agency_id:
            (location?.state as unknown as { agencyId: string })?.agencyId ??
            "",
        job_id: (location?.state as unknown as { jobId: string })?.jobId ?? "",
    });
    const [likeJob] = useLikeJobMutation();
    const [applyJob, { isLoading: isApplyJobFetching }] = useApplyJobMutation();
    const [followAgent, { isLoading: isFollowFetching }] =
        useFollowAgentMutation();
    const [unFollowAgent, { isLoading: isUnFollowFetching }] =
        useUnFollowAgentMutation();
    const [isHeartActive, setIsHeartActive] = useState(false);
    const handleHeartClick = () => {
        setIsHeartActive((prev) => !prev);
        likeJob({
            votable_id: jobDetails?.id ?? "",
            votable_type: "Job",
            user_id: userId ?? "",
        }).then(() => {
            refetch();
        });
    };
    const handleFastApply = async () => {
        try {
            applyJob({
                user_id: userId ?? "",
                job_id: jobDetails?.id ?? "",
            }).then((data) => {
                if (
                    (data as { error: { data: { message: string } } })?.error
                        ?.data
                ) {
                    addToast({
                        type: "error",
                        text: (data as { error: { data: { message: string } } })
                            ?.error?.data?.message,
                    });
                } else {
                    refetch();
                    addToast({
                        type: "success",
                        text: "You have successfully applied for job",
                    });
                }
            });
        } catch (error: any) {
            if (error.status === 422) {
                addToast({
                    type: "error",
                    text:
                        error.data.message ||
                        "You've reached the job casting limit for your subscription.",
                });
            } else {
                addToast({
                    type: "error",
                    text: "An unexpected error occurred. Please try again.",
                });
            }
        }
    };
    useEffect(() => {
        if (jobDetails?.is_wishlisted) {
            setIsHeartActive(true);
        } else {
            setIsHeartActive(false);
        }
    }, [jobDetails]);

    const handleFollowAgency = () => {
        followAgent({
            user_id: userId ?? "",
            agent_id: jobDetails?.agency_id ?? "",
        }).then(() => {
            refetch();
        });
    };
    const handleUnFollowAgency = () => {
        unFollowAgent({
            user_id: userId ?? "",
            agent_id: jobDetails?.agency_id ?? "",
        }).then(() => {
            refetch();
        });
    };
    return (
        <>
            {/* <Navbar /> */}
            <FindWorkWrapper>
                {isLoading && <Loader size={28} />}
                {!isLoading && (
                    <>
                        <Button
                            style={{ marginBottom: "10px" }}
                            variant="outlined"
                            icon={<BsArrowLeft />}
                            iconPosition="prefix"
                            onClick={() => {
                                navigateTo(-1);
                            }}
                        >
                            Back
                        </Button>
                        <StyledRow gutter={16}>
                            <Col span={18}>
                                <Card
                                    title="Casting Details"
                                    bordered={false}
                                    extra={
                                        <BsHeartFill
                                            color={
                                                isHeartActive
                                                    ? "#FF0D41"
                                                    : "#909090"
                                            }
                                            onClick={handleHeartClick}
                                        />
                                    }
                                >
                                    <WorkDetailsContent>
                                        <ContentGrid>
                                            <ContentRow>
                                                <ContentRowLeft>
                                                    <AgencyName>
                                                        <TitleSection>
                                                            <Text
                                                                variant="body2"
                                                                fontWeight="600"
                                                            >
                                                                {
                                                                    jobDetails?.title
                                                                }
                                                            </Text>
                                                        </TitleSection>
                                                        <Text
                                                            variant="body3"
                                                            color={
                                                                theme.colors
                                                                    .grey
                                                                    .secondary
                                                            }
                                                        >
                                                            {jobDetails?.updated_at && (
                                                                <Text
                                                                    variant="body3"
                                                                    color={
                                                                        theme
                                                                            .colors
                                                                            .grey
                                                                            .primary
                                                                    }
                                                                >
                                                                    {formatDistance(
                                                                        new Date(
                                                                            jobDetails?.updated_at ||
                                                                                ""
                                                                        ),
                                                                        new Date()
                                                                    )}{" "}
                                                                    ago
                                                                </Text>
                                                            )}
                                                        </Text>
                                                    </AgencyName>
                                                </ContentRowLeft>
                                                <ContentRowRight>
                                                    {!jobDetails?.applied ? (
                                                        <Button
                                                            onClick={() => {
                                                                handleFastApply();
                                                            }}
                                                        >
                                                            Fast Apply{" "}
                                                            {isApplyJobFetching && (
                                                                <Loader
                                                                    size={28}
                                                                />
                                                            )}
                                                        </Button>
                                                    ) : (
                                                        <Button>Applied</Button>
                                                    )}
                                                    {/* <Text
                                        variant="body3"
                                        color={theme.colors.grey.secondary}
                                    >
                                        1.5K Followers
                                    </Text> */}
                                                </ContentRowRight>
                                            </ContentRow>
                                            <ContainerParent>
                                                <ContentDivide>
                                                    <AgencySection>
                                                        <Grid row={true}>
                                                            <Text
                                                                variant="body3"
                                                                fontWeight="500"
                                                                color={
                                                                    theme.colors
                                                                        .grey
                                                                        .secondary
                                                                }
                                                                style={{
                                                                    marginLeft:
                                                                        "27px",
                                                                }}
                                                            >
                                                                DETAILS
                                                            </Text>
                                                        </Grid>
                                                        <ContentRow spacing>
                                                            <InfoSection>
                                                                <Text
                                                                    variant="body3"
                                                                    fontWeight="500"
                                                                    color={
                                                                        theme
                                                                            .colors
                                                                            .grey
                                                                            .secondary
                                                                    }
                                                                >
                                                                    Description
                                                                </Text>
                                                                <Text
                                                                    variant="body2"
                                                                    fontWeight="600"
                                                                    color="#6C6C6C"
                                                                >
                                                                    {jobDetails?.description ||
                                                                        "-"}
                                                                </Text>
                                                            </InfoSection>
                                                        </ContentRow>
                                                        <ContentRow spacing>
                                                            <InfoSection>
                                                                <Text
                                                                    variant="body3"
                                                                    fontWeight="500"
                                                                    color={
                                                                        theme
                                                                            .colors
                                                                            .grey
                                                                            .secondary
                                                                    }
                                                                >
                                                                    Payment
                                                                </Text>
                                                                <Text
                                                                    variant="body2"
                                                                    fontWeight="600"
                                                                    color="#6C6C6C"
                                                                >
                                                                    {
                                                                        budgetType[
                                                                            jobDetails
                                                                                ?.budget
                                                                                ?.budget_type as keyof typeof budgetType
                                                                        ]
                                                                    }
                                                                </Text>
                                                            </InfoSection>
                                                            <InfoSection>
                                                                <Text
                                                                    variant="body3"
                                                                    fontWeight="500"
                                                                    color={
                                                                        theme
                                                                            .colors
                                                                            .grey
                                                                            .secondary
                                                                    }
                                                                >
                                                                    Language
                                                                </Text>
                                                                <Text
                                                                    variant="body2"
                                                                    fontWeight="600"
                                                                    color="#6C6C6C"
                                                                >
                                                                    {
                                                                        jobDetails?.language
                                                                    }
                                                                </Text>
                                                            </InfoSection>
                                                        </ContentRow>
                                                        <ContentRow spacing>
                                                            <InfoSection>
                                                                <Text
                                                                    variant="body3"
                                                                    fontWeight="500"
                                                                    color={
                                                                        theme
                                                                            .colors
                                                                            .grey
                                                                            .secondary
                                                                    }
                                                                >
                                                                    Amount
                                                                </Text>
                                                                <Text
                                                                    variant="body2"
                                                                    fontWeight="600"
                                                                    color="#6C6C6C"
                                                                >
                                                                    {
                                                                        jobDetails
                                                                            ?.budget
                                                                            ?.min_amount
                                                                    }{" "}
                                                                    {
                                                                        jobDetails
                                                                            ?.budget
                                                                            ?.currency
                                                                    }{" "}
                                                                    -{" "}
                                                                    {
                                                                        jobDetails
                                                                            ?.budget
                                                                            ?.max_amount
                                                                    }{" "}
                                                                    {
                                                                        jobDetails
                                                                            ?.budget
                                                                            ?.currency
                                                                    }{" "}
                                                                    {
                                                                        jobDetails
                                                                            ?.budget
                                                                            ?.duration_cycle
                                                                    }
                                                                </Text>
                                                            </InfoSection>
                                                        </ContentRow>
                                                        <ContentRow spacing>
                                                            <InfoSection>
                                                                <Text
                                                                    variant="body3"
                                                                    fontWeight="500"
                                                                    color={
                                                                        theme
                                                                            .colors
                                                                            .grey
                                                                            .secondary
                                                                    }
                                                                >
                                                                    No of
                                                                    applicants
                                                                </Text>
                                                                <Text
                                                                    variant="body2"
                                                                    fontWeight="600"
                                                                    color="#6C6C6C"
                                                                >
                                                                    {jobDetails
                                                                        ?.applicants
                                                                        ?.length ||
                                                                        0}
                                                                </Text>
                                                            </InfoSection>
                                                            <InfoSection>
                                                                <Text
                                                                    variant="body3"
                                                                    fontWeight="500"
                                                                    color={
                                                                        theme
                                                                            .colors
                                                                            .grey
                                                                            .secondary
                                                                    }
                                                                >
                                                                    Open roles
                                                                </Text>
                                                                <Text
                                                                    variant="body2"
                                                                    fontWeight="600"
                                                                    color="#6C6C6C"
                                                                >
                                                                    {jobDetails?.no_of_seats ||
                                                                        0}
                                                                </Text>
                                                            </InfoSection>
                                                        </ContentRow>
                                                        <ContentRow spacing>
                                                            <InfoSection>
                                                                <Text
                                                                    variant="body3"
                                                                    fontWeight="500"
                                                                    color={
                                                                        theme
                                                                            .colors
                                                                            .grey
                                                                            .secondary
                                                                    }
                                                                >
                                                                    Start Date
                                                                </Text>
                                                                <Text
                                                                    variant="body2"
                                                                    fontWeight="600"
                                                                    color="#6C6C6C"
                                                                >
                                                                    {
                                                                        jobDetails?.start_date
                                                                    }
                                                                </Text>
                                                            </InfoSection>
                                                            <InfoSection>
                                                                <Text
                                                                    variant="body3"
                                                                    fontWeight="500"
                                                                    color={
                                                                        theme
                                                                            .colors
                                                                            .grey
                                                                            .secondary
                                                                    }
                                                                >
                                                                    End Date
                                                                </Text>
                                                                <Text
                                                                    variant="body2"
                                                                    fontWeight="600"
                                                                    color="#6C6C6C"
                                                                >
                                                                    {
                                                                        jobDetails?.end_date
                                                                    }
                                                                </Text>
                                                            </InfoSection>
                                                        </ContentRow>
                                                    </AgencySection>
                                                </ContentDivide>
                                                <ContentDivide>
                                                    <PreferenceSection>
                                                        <Grid row={true}>
                                                            <Text
                                                                variant="body3"
                                                                fontWeight="500"
                                                                color={
                                                                    theme.colors
                                                                        .grey
                                                                        .secondary
                                                                }
                                                            >
                                                                PREFERENCES
                                                            </Text>
                                                        </Grid>
                                                        <ContentRow
                                                            spacing
                                                            removeLeftPadding
                                                        >
                                                            <InfoSection>
                                                                <Text
                                                                    variant="body3"
                                                                    fontWeight="500"
                                                                    color={
                                                                        theme
                                                                            .colors
                                                                            .grey
                                                                            .secondary
                                                                    }
                                                                >
                                                                    Qualification
                                                                </Text>
                                                                <Text
                                                                    variant="body2"
                                                                    fontWeight="600"
                                                                    color="#6C6C6C"
                                                                >
                                                                    {jobDetails?.qualification ??
                                                                        "-"}
                                                                </Text>
                                                            </InfoSection>
                                                        </ContentRow>
                                                        <ContentRow
                                                            spacing
                                                            removeLeftPadding
                                                        >
                                                            <InfoSection>
                                                                <Text
                                                                    variant="body3"
                                                                    fontWeight="500"
                                                                    color={
                                                                        theme
                                                                            .colors
                                                                            .grey
                                                                            .secondary
                                                                    }
                                                                >
                                                                    Seats
                                                                </Text>
                                                                <Text
                                                                    variant="body2"
                                                                    fontWeight="600"
                                                                    color="#6C6C6C"
                                                                >
                                                                    {
                                                                        jobDetails?.no_of_seats
                                                                    }{" "}
                                                                    Persons
                                                                </Text>
                                                            </InfoSection>
                                                            <InfoSection>
                                                                <Text
                                                                    variant="body3"
                                                                    fontWeight="500"
                                                                    color={
                                                                        theme
                                                                            .colors
                                                                            .grey
                                                                            .secondary
                                                                    }
                                                                >
                                                                    Gender
                                                                </Text>
                                                                <Text
                                                                    variant="body2"
                                                                    fontWeight="600"
                                                                    color="#6C6C6C"
                                                                >
                                                                    {capitalize(
                                                                        jobDetails?.gender as string
                                                                    ) || "-"}
                                                                </Text>
                                                            </InfoSection>
                                                            <InfoSection>
                                                                <Text
                                                                    variant="body3"
                                                                    fontWeight="500"
                                                                    color={
                                                                        theme
                                                                            .colors
                                                                            .grey
                                                                            .secondary
                                                                    }
                                                                >
                                                                    Age
                                                                </Text>
                                                                <Text
                                                                    variant="body2"
                                                                    fontWeight="600"
                                                                    color="#6C6C6C"
                                                                >
                                                                    {jobDetails?.applicant_min_age ??
                                                                        0 +
                                                                            " " +
                                                                            (jobDetails?.applicant_min_age_unit ||
                                                                                "yrs")}{" "}
                                                                    -{" "}
                                                                    {jobDetails?.applicant_max_age ??
                                                                        0 +
                                                                            " " +
                                                                            (jobDetails?.applicant_max_age_unit ||
                                                                                "yrs")}
                                                                </Text>
                                                            </InfoSection>
                                                        </ContentRow>
                                                        <ContentRow
                                                            spacing
                                                            removeLeftPadding
                                                        >
                                                            <InfoSection>
                                                                <Text
                                                                    variant="body3"
                                                                    fontWeight="500"
                                                                    color={
                                                                        theme
                                                                            .colors
                                                                            .grey
                                                                            .secondary
                                                                    }
                                                                >
                                                                    Height
                                                                </Text>
                                                                {jobDetails
                                                                    ?.physical_details
                                                                    ?.min_height &&
                                                                jobDetails
                                                                    ?.physical_details
                                                                    ?.max_height ? (
                                                                    <Text
                                                                        variant="body2"
                                                                        fontWeight="600"
                                                                        color="#6C6C6C"
                                                                    >
                                                                        {
                                                                            jobDetails
                                                                                ?.physical_details
                                                                                ?.min_height
                                                                        }
                                                                        -
                                                                        {
                                                                            jobDetails
                                                                                ?.physical_details
                                                                                ?.max_height
                                                                        }
                                                                        cm
                                                                    </Text>
                                                                ) : (
                                                                    "-"
                                                                )}
                                                            </InfoSection>
                                                            <InfoSection>
                                                                <Text
                                                                    variant="body3"
                                                                    fontWeight="500"
                                                                    color={
                                                                        theme
                                                                            .colors
                                                                            .grey
                                                                            .secondary
                                                                    }
                                                                >
                                                                    Weight
                                                                </Text>
                                                                {jobDetails
                                                                    ?.physical_details
                                                                    ?.min_weight &&
                                                                jobDetails
                                                                    ?.physical_details
                                                                    ?.max_weight ? (
                                                                    <Text
                                                                        variant="body2"
                                                                        fontWeight="600"
                                                                        color="#6C6C6C"
                                                                    >
                                                                        {
                                                                            jobDetails
                                                                                ?.physical_details
                                                                                ?.min_weight
                                                                        }
                                                                        -
                                                                        {
                                                                            jobDetails
                                                                                ?.physical_details
                                                                                ?.max_weight
                                                                        }
                                                                        kg
                                                                    </Text>
                                                                ) : (
                                                                    "-"
                                                                )}
                                                            </InfoSection>
                                                            <InfoSection>
                                                                <Text
                                                                    variant="body3"
                                                                    fontWeight="500"
                                                                    color={
                                                                        theme
                                                                            .colors
                                                                            .grey
                                                                            .secondary
                                                                    }
                                                                >
                                                                    Tattoos
                                                                </Text>
                                                                <Text
                                                                    variant="body2"
                                                                    fontWeight="600"
                                                                    color="#6C6C6C"
                                                                >
                                                                    {
                                                                        yesNoType[
                                                                            jobDetails
                                                                                ?.physical_details
                                                                                ?.tattoos as keyof typeof yesNoType
                                                                        ]
                                                                    }
                                                                </Text>
                                                            </InfoSection>
                                                        </ContentRow>
                                                        <ContentRow
                                                            spacing
                                                            removeLeftPadding
                                                        >
                                                            <InfoSection>
                                                                <Text
                                                                    variant="body3"
                                                                    fontWeight="500"
                                                                    color={
                                                                        theme
                                                                            .colors
                                                                            .grey
                                                                            .secondary
                                                                    }
                                                                >
                                                                    Piercings
                                                                </Text>
                                                                <Text
                                                                    variant="body2"
                                                                    fontWeight="600"
                                                                    color="#6C6C6C"
                                                                >
                                                                    {
                                                                        yesNoType[
                                                                            jobDetails
                                                                                ?.physical_details
                                                                                ?.piercings as keyof typeof yesNoType
                                                                        ]
                                                                    }
                                                                </Text>
                                                            </InfoSection>
                                                            <InfoSection>
                                                                <Text
                                                                    variant="body3"
                                                                    fontWeight="500"
                                                                    color={
                                                                        theme
                                                                            .colors
                                                                            .grey
                                                                            .secondary
                                                                    }
                                                                >
                                                                    Hair Length
                                                                </Text>
                                                                <Text
                                                                    variant="body2"
                                                                    fontWeight="600"
                                                                    color="#6C6C6C"
                                                                >
                                                                    {
                                                                        jobDetails
                                                                            ?.physical_details
                                                                            ?.hair_length
                                                                    }
                                                                    cm
                                                                </Text>
                                                            </InfoSection>
                                                            <InfoSection>
                                                                <Text
                                                                    variant="body3"
                                                                    fontWeight="500"
                                                                    color={
                                                                        theme
                                                                            .colors
                                                                            .grey
                                                                            .secondary
                                                                    }
                                                                >
                                                                    Hair color
                                                                </Text>
                                                                <Text
                                                                    variant="body2"
                                                                    fontWeight="600"
                                                                    color="#6C6C6C"
                                                                >
                                                                    {capitalize(
                                                                        jobDetails
                                                                            ?.physical_details
                                                                            ?.hair_color as string
                                                                    )}
                                                                </Text>
                                                            </InfoSection>
                                                        </ContentRow>
                                                        <ContentRow
                                                            spacing
                                                            removeLeftPadding
                                                        >
                                                            <InfoSection>
                                                                <Text
                                                                    variant="body3"
                                                                    fontWeight="500"
                                                                    color={
                                                                        theme
                                                                            .colors
                                                                            .grey
                                                                            .secondary
                                                                    }
                                                                >
                                                                    Burst
                                                                </Text>
                                                                <Text
                                                                    variant="body2"
                                                                    fontWeight="600"
                                                                    color="#6C6C6C"
                                                                >
                                                                    {jobDetails
                                                                        ?.physical_details
                                                                        ?.bust
                                                                        ? `${jobDetails?.physical_details?.bust}cm`
                                                                        : "-"}
                                                                </Text>
                                                            </InfoSection>
                                                            <InfoSection>
                                                                <Text
                                                                    variant="body3"
                                                                    fontWeight="500"
                                                                    color={
                                                                        theme
                                                                            .colors
                                                                            .grey
                                                                            .secondary
                                                                    }
                                                                >
                                                                    Waist
                                                                </Text>
                                                                <Text
                                                                    variant="body2"
                                                                    fontWeight="600"
                                                                    color="#6C6C6C"
                                                                >
                                                                    {jobDetails
                                                                        ?.physical_details
                                                                        ?.waist
                                                                        ? `${jobDetails?.physical_details?.waist}cm`
                                                                        : "-"}
                                                                </Text>
                                                            </InfoSection>
                                                            <InfoSection>
                                                                <Text
                                                                    variant="body3"
                                                                    fontWeight="500"
                                                                    color={
                                                                        theme
                                                                            .colors
                                                                            .grey
                                                                            .secondary
                                                                    }
                                                                >
                                                                    Hips
                                                                </Text>
                                                                <Text
                                                                    variant="body2"
                                                                    fontWeight="600"
                                                                    color="#6C6C6C"
                                                                >
                                                                    {jobDetails
                                                                        ?.physical_details
                                                                        ?.hips
                                                                        ? `${jobDetails?.physical_details?.hips}cm`
                                                                        : "-"}
                                                                </Text>
                                                            </InfoSection>
                                                        </ContentRow>
                                                    </PreferenceSection>
                                                </ContentDivide>
                                            </ContainerParent>
                                        </ContentGrid>
                                    </WorkDetailsContent>
                                </Card>
                            </Col>
                            <Col span={6}>
                                <Card title="Agency Details" bordered={false}>
                                    <AgencyInformation>
                                        <ContentRowLeft>
                                            <AgencyIcon
                                                src={
                                                    jobDetails?.agency
                                                        ?.company_logo as unknown as string
                                                }
                                                alt="Agency icon"
                                            />
                                            <AgencyName>
                                                <Text
                                                    variant="body2"
                                                    fontWeight="600"
                                                >
                                                    {jobDetails?.agency?.name}
                                                </Text>
                                                <Text
                                                    variant="body3"
                                                    color={
                                                        theme.colors.grey
                                                            .secondary
                                                    }
                                                >
                                                    <IoLocation />
                                                    {jobDetails?.city}
                                                    {/*{jobDetails?.city + " , " + jobDetails?.country_name}*/}
                                                </Text>
                                            </AgencyName>
                                        </ContentRowLeft>
                                        <ContentRowRight>
                                            <Button
                                                variant="outlined"
                                                onClick={() => {
                                                    navigateTo(
                                                        routeConstants.agencyInformation +
                                                            "/" +
                                                            jobDetails?.agency_id
                                                    );
                                                }}
                                            >
                                                View
                                            </Button>
                                            {!jobDetails?.agency_followed_by_user && (
                                                <Button
                                                    variant="outlined"
                                                    onClick={() => {
                                                        handleFollowAgency();
                                                    }}
                                                >
                                                    Follow{" "}
                                                    {isFollowFetching && (
                                                        <Loader />
                                                    )}
                                                </Button>
                                            )}
                                            {jobDetails?.agency_followed_by_user && (
                                                <Button
                                                    variant="outlined"
                                                    onClick={() => {
                                                        handleUnFollowAgency();
                                                    }}
                                                >
                                                    UnFollow{" "}
                                                    {isUnFollowFetching && (
                                                        <Loader />
                                                    )}
                                                </Button>
                                            )}
                                            {/* <Text
                                        variant="body3"
                                        color={theme.colors.grey.secondary}
                                    >
                                        1.5K Followers
                                    </Text> */}
                                        </ContentRowRight>
                                    </AgencyInformation>
                                </Card>
                            </Col>
                        </StyledRow>
                    </>
                )}
            </FindWorkWrapper>
        </>
    );
};
